<form [formGroup]="form">
  <div class="gap-lg grid">
    @if (!idAptitude()) {
      <div hlmField>
        <label hlmFieldLabel for="select-referentiel">Aptitude liée</label>
        <hlm-select id="select-aptitude" formControlName="aptitude" placeholder="Sélectionnez une aptitude">
          <hlm-select-trigger>
            <hlm-select-value />
          </hlm-select-trigger>

          <hlm-select-content>
            @for (aptitude of aptitudes(); track $index) {
              <hlm-option [value]="aptitude.id">
                {{ aptitude.nom }}
              </hlm-option>
            }
          </hlm-select-content>
        </hlm-select>
      </div>
    }

    <div class="gap-lg grid" formArrayName="productions">
      @for (form of productions.controls; track $index; let idx = $index) {
        <app-expansion-panel [titre]="'Production ' + (idx + 1)" [item]="idx" [isOpen]="true">
          <div class="p-lg" [formGroupName]="idx" hlmField>
            <label [for]="'nom-' + idx" hlmFieldLabel labelRequired>Nom de la production</label>
            <input [id]="'nom-' + idx" hlmInput type="text" formControlName="nom" />
            @if (form.get('nom')?.hasError('required') && form.touched) {
              <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
            }
            @if (form.get('nom')?.hasError('notUnique')) {
              <hlm-field-error>Cette production existe déjà</hlm-field-error>
            }
          </div>
        </app-expansion-panel>
      }
    </div>
    <app-button-add-new (click)="addProduction()" label="Ajouter une autre production" />
  </div>
</form>
